/**
 * Which campuses the current user may run Term End Adjust / Grade +1 on.
 * Server re-checks the same rule (termRolloverFn.authorize).
 */
export const getTermEndAdjustCampuses = (campuses, { isSystemAdmin, userCampusIds }) => {
  const enabled = (campuses || []).filter(c => c.termEndAdjust === true);
  if (isSystemAdmin) return enabled;
  const mine = new Set(userCampusIds || []);
  return enabled.filter(c => mine.has(c.id));
};
